<template>
  <div>
    <div class="row">
      <div class="col">
        <label class="form-control-label"
          >OTP Configuration <span class="text-danger">*</span></label
        >
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <a-select
          v-model="duration"
          :disabled="viewMode"
          @change="handleDurationChange"
        >
          <a-select-option
            v-for="(duration, key) in options.durations"
            :key="key"
            :value="duration.length"
          >
            {{ duration.length + ' ' + duration.unitLabel }}
          </a-select-option>
        </a-select>
        <small
          ><strong><i>Duration</i></strong
          >&nbsp;
          <a-tooltip placement="right">
            <template slot="title">
              <span
                ><small>OTP code validation period upon request.</small></span
              >
            </template>
            <small>
              <i class="fa fa-info-circle" aria-hidden="true" />
            </small> </a-tooltip
        ></small>
        <div
          v-if="
            $v.formData.duration.length.$dirty ||
            $v.formData.duration.unit.$dirty
          "
          class="text-danger"
        >
          <div
            class="error"
            v-if="
              !$v.formData.duration.length.required ||
              !$v.formData.duration.unit.required
            "
          >
            Field is required
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <a-select
          v-model="refreshRate"
          :disabled="viewMode"
          @change="handleRefreshRateChange"
        >
          <a-select-option
            v-for="(refresh, key) in options.refreshes"
            :key="key"
            :value="refresh.interval"
          >
            {{ refresh.interval + ' ' + refresh.unitLabel }}
          </a-select-option>
        </a-select>
        <small
          ><strong><i>Refresh Rate</i></strong> &nbsp;
          <a-tooltip placement="right">
            <template slot="title">
              <span
                ><small
                  >Waiting time before app can request new OTP code</small
                ></span
              >
            </template>
            <small>
              <i class="fa fa-info-circle" aria-hidden="true" />
            </small> </a-tooltip
        ></small>

        <div
          v-if="
            $v.formData.refresh.interval.$dirty ||
            $v.formData.refresh.unit.$dirty
          "
          class="text-danger"
        >
          <div
            class="error"
            v-if="
              !$v.formData.refresh.interval.required ||
              !$v.formData.refresh.unit.required
            "
          >
            Field is required
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'MembershipProgramOtpTab',
  props: {
    otpConfigData: {
      type: Object,
      default: () => ({
        duration: {
          length: 5,
          unit: 'minutes'
        },
        refresh: {
          interval: 60,
          unit: 'seconds'
        }
      })
    },
    viewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      duration: null,
      refreshRate: null,
      options: {
        durations: [
          { length: 1, unitLabel: 'min', unit: 'minutes' },
          { length: 2, unitLabel: 'min', unit: 'minutes' },
          { length: 3, unitLabel: 'min', unit: 'minutes' },
          { length: 5, unitLabel: 'min', unit: 'minutes' }
        ],
        refreshes: [
          { interval: 30, unitLabel: 'sec', unit: 'seconds' },
          { interval: 60, unitLabel: 'sec', unit: 'seconds' },
          { interval: 120, unitLabel: 'sec', unit: 'seconds' }
        ]
      }
    };
  },
  validations: {
    formData: {
      duration: {
        length: { required },
        unit: { required }
      },
      refresh: {
        interval: { required },
        unit: { required }
      }
    }
  },
  methods: {
    initFormData() {
      // NOTE: Default values
      this.duration = 1;
      this.refreshRate = 60;
      this.formData = {
        duration: {
          length: 1,
          unit: 'minutes'
        },
        refresh: {
          interval: 60,
          unit: 'seconds'
        }
      };
    },

    setFormData(otpConfigData) {
      console.log('OTP set form data: ', otpConfigData);
      if (otpConfigData !== null) {
        if (typeof otpConfigData === 'string') {
          otpConfigData = JSON.parse(otpConfigData);
        }

        const { length: durationLength, unit: durationUnit } =
          otpConfigData.duration;

        const { interval: refreshInterval, unit: refreshUnit } =
          otpConfigData.refresh;

        this.formData = {
          duration: {
            length: durationLength,
            unit: durationUnit
          },
          refresh: {
            interval: refreshInterval,
            unit: refreshUnit
          }
        };

        const _duration = this.options.durations.find(
          (_) => _.length === parseInt(durationLength)
        );

        const _refresh = this.options.refreshes.find(
          (_) => _.interval === parseInt(refreshInterval)
        );

        this.duration = _duration?.length ?? null;
        this.refreshRate = _refresh?.interval ?? null;
      } else {
        this.initFormData();
      }
    },

    clearForm() {
      this.initFormData();
      this.$v.formData.$reset();
    },

    handleDurationChange(_, node) {
      const selectedOpt = this.options.durations[node.key];
      this.formData.duration.length = selectedOpt.length;
      this.formData.refresh.unit = selectedOpt.unit;
    },
    handleRefreshRateChange(_, node) {
      const selectedOpt = this.options.refreshes[node.key];
      this.formData.refresh.interval = selectedOpt.interval;
      this.formData.refresh.unit = selectedOpt.unit;
    }
  },
  created() {
    this.setFormData(this.otpConfigData);
  },
  watch: {
    otpConfigData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>
